import { commonDomains } from './common'
import getuniqDomains from './getuniq'
import adsimpleDomains from './adsimple'

const productDomains = process.env.REACT_APP_PRODUCT === 'adsimple' ? adsimpleDomains : getuniqDomains

export const APP_DOMAINS = {
  ...commonDomains,
  ...productDomains,
}

export const domainManifests = Object.fromEntries(
  Object.entries(APP_DOMAINS).map(([domainId, { manifest }]) => [domainId, manifest]),
)

export const DOMAIN_TO_I18N_NAMESPACES = Object.fromEntries(
  Object.entries(APP_DOMAINS).map(([domainId, { i18nNamespaces }]) => [domainId, i18nNamespaces]),
)
